import UTC2Local from "../../../../UTC2Local";

export const getTable = () => {
    return {
      columns: [
        {
          id: "employee",
          label: "attendance.list.column.employeeName",
          align: "left",
          visible: true,
          renderCell: (row) => {
            return (
              (row?.firstName || "") +
              " " +
              (row?.lastName || "")
            );
          },
        },
      ],
      defaultSort: "FirstName",
      defaultSortDirection: "asc",
    };
  };
  